/**Dependencies */
import React from "react";

/**Components */
import { Row, Col } from "react-bootstrap";
import Slider from "react-slick";

/**Images */
import iconAsesory from "../images/icons/Ahorra tiempo.png";
import iconPay from "../images/icons/Atencion al cliente.png";
import iconCalendar from "../images/icons/Colecciones por temporada.png";

export const SectionAdvise = () => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
    ],
  };

  return (
    <div className="section-advise container">
      <h1 className="text-center pb-5">
        Beneficios de viajar con <br /> Agencia Marzah
      </h1>

      <Slider {...settings}>
        {/* Sección 1 */}
        <div className="text-center p-3">
          <Row>
            <Col lg={10}>
              <div className="d-flex justify-content-center">
                <img src={iconCalendar} alt="" className="icon" width={50} />
              </div>
              <div className="pt-5">
                <h5 style={{ fontWeight: "bold" }}>
                  Colecciones por temporada
                </h5>
                <p className="mt-3">
                  Conoce el mundo y siente la libertad en cada estación del año
                  con nuestras colecciones diseñadas especialmente para ti.
                </p>
              </div>
            </Col>
            {/*  <Col lg={2}><div className='separator-rose' style={{ width: '1px', height: '140px', backgroundColor: '#f08abc', margin: '60px 20px', padding:'2px' }}></div></Col> */}
          </Row>
        </div>

        {/* Sección 2 */}
        <div className="text-center p-3">
          <Row>
            <Col lg={10}>
              <div className="d-flex justify-content-center">
                <img src={iconPay} width={100} className="icon" alt="" />
              </div>
              <div className="pt-5">
                <h5 style={{ fontWeight: "bold" }}>Atención al cliente</h5>
                <p className="text-purple mt-3">
                  ¿Tienes dudas? Chatea en vivo con nuestro equipo de atención
                  al cliente para poder solucionar tus preguntas.
                </p>
              </div>
            </Col>
            {/* <Col lg={2}>
                <div className='separator-rose' style={{ width: '1px', height: '140px', backgroundColor: '#f08abc', margin: '60px 20px', padding:'2px' }}></div>
              </Col>  */}
          </Row>
        </div>
        {/*  <div className='separator-rose' style={{ width: '1px', height: '160px', backgroundColor: '#f08abc', margin: '0 20px', padding:'2px' }}></div> */}

        {/* Sección 3 */}
        <div className="text-center p-3">
          <div className="d-flex justify-content-center">
            <img src={iconAsesory} className="icon" alt="" width={90} />
          </div>
          <div className="pt-5">
            <h5 style={{ fontWeight: "bold" }}>Ahorra tiempo y dinero</h5>
            <p className="text-purple mt-3">
              Somos una agencia que trabaja de la mano con proveedores para
              poder obtener los mejores productos y precios para nuestros
              usuarios.
            </p>
          </div>
        </div>
      </Slider>
    </div>
  );
};
